import React, { useState } from 'react';
import ProjeSorumlusuSection from '../baslikSections/ProjeSorumlusuSection';
import ProjeMuellifiSection from '../baslikSections/ProjeMuellifiSection';
import ProjeyiYaptiranSection from '../baslikSections/ProjeyiYaptiranSection';
import ArsaOzellikleriSection from '../baslikSections/ArsaOzellikleriSection';
import YapiOzellikleriSection from '../baslikSections/YapiOzellikleriSection';

const SECTIONS = [
  { id: 'projeSorumlusu', label: 'Proje Sorumlusu', component: ProjeSorumlusuSection },
  { id: 'projeMuellifi', label: 'Proje Muellifi & Onay', component: ProjeMuellifiSection },
  { id: 'projeyiYaptiran', label: 'Projeyi Yaptiran', component: ProjeyiYaptiranSection },
  { id: 'arsaOzellikleri', label: 'Arsanin Ozellikleri', component: ArsaOzellikleriSection },
  { id: 'yapiOzellikleri', label: 'Yapinin Ozellikleri', component: YapiOzellikleriSection },
];

export default function BaslikTab() {
  const [openSections, setOpenSections] = useState(
    SECTIONS.reduce((acc, s) => ({ ...acc, [s.id]: true }), {})
  );

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({ ...prev, [sectionId]: !prev[sectionId] }));
  };

  return (
    <div className="panel-detail-tab">
      {SECTIONS.map(({ id, label, component: Component }) => (
        <div key={id} className="detail-accordion">
          <button
            className="detail-accordion-header"
            onClick={() => toggleSection(id)}
          >
            <span className="detail-accordion-arrow">
              {openSections[id] ? '\u25BC' : '\u25B6'}
            </span>
            {label}
          </button>
          {openSections[id] && <Component />}
        </div>
      ))}
    </div>
  );
}
